/** @jsx jsx */
import { jsx } from '@emotion/core';
import { CurrencyRulesetItem } from '@zapier/payment/src/hooks/useCurrencyRuleset';
import PaymentMethodImage from '@zapier/payment/src/components/PaymentMethodImage';
import { CreditCardBrandCode } from '@zapier/payment/src/types';

type Props = {
  /** Show small version of images */
  isSmall?: boolean;
  methods: Array<CurrencyRulesetItem>;
  /** All other payment method icons will be greyed out */
  selectedMethod?: CreditCardBrandCode | undefined | null;
};

const wrapperCss = {
  'span + span, span + svg': {
    marginLeft: 15,
  },
};

const PaymentMethodImageStrip: React.FC<Props> = ({
  isSmall = false,
  methods = [],
}) => {
  const images = methods.map((method: CurrencyRulesetItem) => {
    return (
      <PaymentMethodImage
        imageType={method.submethod}
        isSmall={isSmall}
        key={method.submethod}
      />
    );
  });
  return <div css={wrapperCss}>{images}</div>;
};

export default PaymentMethodImageStrip;
